// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import "babel-polyfill"
// import BaiduMap from 'vue-baidu-map'

Vue.config.productionTip = false

// Vue.use(BaiduMap, {
//   ak: 'EslUjST9yPPU5uh9Vv3362YDZ2BOHs0X'  //这个地方是官方提供的ak密钥
// })
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    // document.title = to.meta.title;
    document.title = '深圳市万连供应链有限公司';
  }
  next()
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js